<template>
<v-layout>
<nav>
<div class="hide-overflow" style="position: relative;">
  <v-toolbar v-if="partner === 'establishment'" color="primary" dark fixed app>
       <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <span v-if="true">
        <ticket-notifications />
      </span>
      <v-btn icon @click="signout">
        <v-icon>exit_to_app</v-icon>
      </v-btn>
    </v-toolbar>
    <v-toolbar v-else v-bind:color="color" dark fixed app>
       <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
      <v-spacer></v-spacer>

      <span v-if="true">
        <ticket-notifications />
      </span>
      <v-btn icon @click="signout">
        <v-icon>exit_to_app</v-icon>
      </v-btn>
    </v-toolbar>
  </div>
</nav>
  <v-navigation-drawer
    v-model="drawer"
    app
    :mini-variant="miniVariant"
    mini-variant-width="80"
  >
  <sidemenu-header />
  <div v-if="partner === 'establishment'">
    <sidemenu-items />
  </div>
  <div v-else>
    <sidemenu-itemsPartner />
  </div>
  </v-navigation-drawer>
  </v-layout>
</template>
<script>
import { EventBus } from '@/services/event-bus';
import { mapGetters } from 'vuex';

export default {
  name: 'Sidemenu',
  data() {
    return {
      drawer: false,
      miniVariant: false,
      right: null,
      pageTitle: 'Painel do Cliente',
    };
  },
  components: {
    SidemenuHeader: () => import('./SidemenuHeader.vue'),
    SidemenuItems: () => import('./SidemenuItems.vue'),
    SidemenuItemsPartner: () => import('./SidemenuItemsPartner.vue'),
    TicketNotifications: () => import('@/components/tickets/TicketNotifications.vue'),
  },
  created() {
    this.$store.dispatch('account/getAccount');
    EventBus.$on('hide-side-menu', () => {
      this.miniVariant = !this.miniVariant;
    });
    document.title = this.pageTitle;

    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = this.favicon || '/favicon.ico';
  },
  computed: {
    ...mapGetters({
      account: 'account/account',
      partner: 'account/partner',
      logo: 'account/logoLink',
      favicon: 'account/favicon',
      color: 'account/color',
      partnerName: 'account/partnerName',
    }),
  },
  watch: {
    color(newValues) {
      this.newAccount = newValues;
    },
    account(newValues) {
      // this.pageTitle = newValues['fantasy_name'];
      if (newValues['fantasy_name'] === null) {
      document.title = this.pageTitle;
      } else {
        this.pageTitle = newValues['fantasy_name'];
      }

      var link = document.querySelector("link[rel~='icon']");
      if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = newValues['styles'] && newValues['styles']['partner_favicon'] || this.favicon || '/favicon.ico';
    }
  },
  methods: {

    signout() {
      this.$flowit.token.destroy();
      this.$router.go('login');
    },
    openFullscreen() {
      let elem = document.getElementById("app");

      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
      }
    }
  },
};
</script>
